// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3HiMa","header":"PatientQuestionnaire_header__2ZDWk","info":"PatientQuestionnaire_info__2Jcho"};